cb.define([], function () {
  var RM_rm_gatherdailyreportlist_VM_Extend = {

    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },
    init: function (viewmodel) {
		let gridModel = viewmodel.getGridModel();
		gridModel.on('jointQuery', function (args) {
					var params = {
						mode: 'edit',
						readOnly: true,
						id: args.rowData.rmDailyReport
					};
					var data = {
						billtype: 'voucher',
						billno: 'rm_dailyreport',
						params: params
					};
					cb.loader.runCommandLine('bill', data, viewmodel);
				});
	 }
  }
  try {
    module.exports = RM_rm_gatherdailyreportlist_VM_Extend;
  } catch (error) {

  }
  return RM_rm_gatherdailyreportlist_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/RM/RM_rm_gatherdailyreportlist_VM.Extend.js